import type { SelectedFreelancer } from "../store/freelance-search-store";
import type { FreelanceSheetData, SendProposalRequest } from "../types";

/**
 * Selezione → store. Il `search_id` viene stampato **al momento della
 * selezione** (D3): l'invio proposte avviene su una route successiva, da una
 * lista che può mescolare i due tab, e questo è l'unico punto in cui si sa da
 * dove il freelancer è stato preso. Dal pool l'oggetto sorgente non porta il
 * campo, quindi la chiave non nasce affatto.
 */
export const toSelectedFreelancer = (
  freelancer: FreelanceSheetData,
): SelectedFreelancer => ({
  id: String(freelancer.id),
  full_name: freelancer.full_name ?? "",
  avatar_url: freelancer.avatar_url ?? "",
  job_title: freelancer.job_title ?? "",
  already_applied: freelancer.already_applied,
  ...(freelancer.search_id ? { search_id: freelancer.search_id } : {}),
});

/**
 * Body della proposta, per-freelancer: in un batch misto ricerca+pool ogni
 * POST porta l'id della propria provenienza, o nessuno.
 */
export const buildSendProposalRequest = (
  jobOfferId: string,
  freelancer: SelectedFreelancer,
): SendProposalRequest => ({
  job_offer_id: jobOfferId,
  profile_id: freelancer.id,
  ...(freelancer.search_id ? { search_id: freelancer.search_id } : {}),
});
